import { RangeKey } from '@common/enum';
import { RangeFilter } from '@common/filters/range-filter';
import { DatesService } from '@common/services';

export class CopiesEvolFilter extends RangeFilter
{
    policyName: string;
    server: string;
    residence: string;
    slpName: string;

    constructor ()
    {
        super();

        this.initFilter();
    }

    public static mapperFromObject (source: any): CopiesEvolFilter
    {
        const target = new CopiesEvolFilter();

        Object.assign(target, source);

        return target;
    }

    private initFilter ()
    {
        const { since, until } = DatesService.preRangeDatesStatic(RangeKey.CURRENT7DAYS);

        this.rangeSince = since;
        this.rangeUntil = until;
    }
}
